import { InsertDriveFileRounded } from '@mui/icons-material';
import { Box } from '@mui/material';
import { IconButton } from 'component/MarketPlace/ButtonComponents';
import Typography from 'component/MarketPlace/Typography';
import styled from 'styled-components';

export const StyledContainer = styled(Box)<{ isMobile?: boolean }>(({ isMobile }) => `
  position: relative;
  padding: ${isMobile ? '20px 32px' : '40px 60px'};
  @media screen and (min-width: 600px) {
    min-width: 600px;
  }
`);

export const StyledCloseButton = styled(IconButton)(({ theme }) => `
 &.MuiIconButton-root {
   position: absolute;
   top: ${theme.uptimeSpace[7]}px;
   right: ${theme.uptimeSpace[7]}px;
  }
`);

export const StyledCard = styled(Box)(({ theme }) => `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 164px;
  background-color: ${theme.uptimeColors.grayScales.lightGray};
  border-radius: 8px;
  width: 100%;
  @media screen and (min-width: 600px) {
    width: 270px;
  }
`);

export const StyledFileIcon = styled(Box)(({ theme }) => `
  position: relative;
  & .MuiSvgIcon-root {
    color: ${theme.uptimeColors.grayScales.darkerGray};
  }
`);

export const StyledFileInfo = styled(Box)(({ theme }) => `
  display: flex;
  align-items: center;
  margin-top: ${theme.uptimeSpace[8]}px;
`);

export const StyledFileName = styled(Typography)(({ theme }) => `
  &.MuiTypography-root {
    position: absolute;
    bottom: ${theme.uptimeSpace[4]}px;
    left: 50%;
    transform: translateX(-50%);
    font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
    font-weight: 700;
    color: ${theme.uptimeColors.grayScales.white};
    text-transform: uppercase;
  }
`);

export const StyledInsertDriveFile = styled(InsertDriveFileRounded)(({ theme }) => `
  &.MuiSvgIcon-root {
    font-size: 3rem;
  }
`);

export const StyledActionButton = styled(Box)(({ theme }) => `
  position: absolute;
  top: ${theme.uptimeSpace[4]}px;
  right: ${theme.uptimeSpace[4]}px;
`);
